import { CSSProperties } from 'react'

export const timeZoneDropdownStyles: Pick<CSSProperties, 'minWidth'> = {
  minWidth: 'max-content',
}
